import { Component, Element, Host, h, Prop } from '@stencil/core';

interface ConditionResultInterface {
  loops: number;
  mail: { form: number };
  todo?: any;
}

const DUMMY_MODEL_VALUE = 'asdfasdshsfghdfgh23456789';

@Component({
  tag: 'uvex-form-condition',
})
export class FormCondition {
  @Element() el!: HTMLElement;
  @Prop() formConditionUrl!: string;
  private inputs: NodeList;
  private formData: FormData;

  componentDidLoad() {
    this.inputs = this.el.querySelectorAll('input,textarea,select,uvex-select');
    this.fetchConditions();
    this.bindChangeEvents();
  }

  private bindChangeEvents() {
    this.inputs.forEach(input => {
      input.addEventListener('change', _ => this.fieldChanged());
    });
  }

  private fieldChanged() {
    this.fetchConditions();
  }

  private fetchConditions() {
    try {
      const XHR = new XMLHttpRequest();
      this.formData = new FormData(this.el.querySelector('form'));

      XHR.addEventListener('load', event => {
        let responseText = JSON.parse((event.target as XMLHttpRequest).responseText) as ConditionResultInterface;
        this.processActions(responseText);
      });

      XHR.open('POST', this.formConditionUrl);
      XHR.send(this.formData);
    } catch (e) {}
  }

  private processActions(data: ConditionResultInterface) {
    if (!data.todo) {
      return;
    }
    Array.from(Object.keys(data.todo)).forEach(formUid => this.processForm(data.todo[formUid]));
  }

  private processForm(form) {
    Array.from(Object.keys(form)).forEach(fieldsetUid => this.processFieldset(form[fieldsetUid], fieldsetUid));
  }

  private processFieldset(fieldset, fieldUid: string) {
    const $fieldset = document.querySelector('#fieldset-' + fieldUid) as HTMLElement;
    if (fieldset['#action'] === 'hide') {
      $fieldset.setAttribute('hidden', 'hidden');
      $fieldset.setAttribute('disabled', 'disabled');
    } else if (fieldset['#action'] === 'un_hide') {
      $fieldset.removeAttribute('hidden');
      $fieldset.removeAttribute('disabled');
    }

    Array.from(Object.keys(fieldset))
      .filter(fieldName => fieldName !== '#action')
      .filter(fieldName => fieldName !== 'matching_condition')
      .forEach(fieldName => this.processField(fieldset[fieldName], fieldName));
  }

  private processField(field: any, fieldName: string) {
    const $container = document.querySelector('#field-' + fieldName);
    const $field = $container.querySelector('input,textarea,select,uvex-select');

    if ($field) {
      if (field['#action'] === 'hide') {
        $container.setAttribute('hidden', 'hidden');
        $field.setAttribute('disabled', 'disabled');

        // Set dummy model value to reset required validation
        if ($field.hasAttribute('required') && !this.hasModelValue(fieldName)) {
          this.setDummyModelValue(fieldName);
        }
      } else if (field['#action'] === 'un_hide') {
        $container.removeAttribute('hidden');
        $field.removeAttribute('disabled');

        // Unset dummy model value
        if ($field.hasAttribute('required') && !this.hasModelValue(fieldName)) {
          this.unsetDummyModelValue(fieldName);
        }
      }
    }
  }
  private hasModelValue(fieldName) {
    const fieldData = this.formData[fieldName];
    if (Array.isArray(fieldData) && fieldData[0] !== DUMMY_MODEL_VALUE) {
      return true;
    }
    return fieldData !== '' && fieldData !== DUMMY_MODEL_VALUE;
  }
  private setDummyModelValue(fieldName) {
    if (Array.isArray(this.formData[fieldName])) {
      this.formData[fieldName][0] = DUMMY_MODEL_VALUE;
    } else {
      this.formData[fieldName] = DUMMY_MODEL_VALUE;
    }
  }
  private unsetDummyModelValue(fieldName) {
    if (Array.isArray(this.formData[fieldName])) {
      this.formData[fieldName] = [];
    } else {
      this.formData[fieldName] = '';
    }
  }

  render() {
    return (
      <Host>
        <slot />
      </Host>
    );
  }
}
